import AppForm from '../app-components/Form/AppForm';

Vue.component('book-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                nama:  '' ,
                pengarang:  '' ,
                deskripsi:  '' ,
                enabled:  false ,
                
            },
            tempDeskripsi: ''
        }
    },
    methods: {
      actionChange: function (event) {
          // `this` inside methods points to the Vue instance
          // `event` is the native DOM event
          if (event) {
            alert(event.target.tagName+" value: " + event.target.value)
            this.tempDeskripsi = event.target.value
          }
        }
      }

});